<script>
import splitting from '@/directives/splitting'
import 'splitting/dist/splitting.css'
import 'splitting/dist/splitting-cells.css'
// import Splitting from 'splitting'

export default {
  name: 'CharSplitText',
  directives: { splitting },
  props: {
    tag: {
      type: String,
      required: false,
      default: 'span'
    },
    transition: {
      type: String,
      required: false,
      default: null
    },
    transitionKey: {
      required: false,
      default: null
    },
    text: {
      type: String,
      required: true
    }
  },
  render (h) {
    if (this.$root.platform.prerenderer || this.$root.platform.ie11) {
      return h(this.tag, { domProps: { innerHTML: this.text } })
    }

    // return h(
    //   'transition',
    //   { props: { appear: true } },
    //   [
    //     h(this.tag, {
    //       class: { 'split-text': true },
    //       key: this.text,
    //       domProps: { innerHTML: Splitting.html({ content: this.text, by: 'chars' }) }
    //     })
    //   ]
    // )

    return h(
      'transition',
      { props: { appear: true, name: this.transition, mode: 'out-in' } },
      [
        h(
          this.tag,
          {
            key: this.transitionKey || this.text,
            class: { 'split-text': true },
            domProps: { innerHTML: this.text },
            directives: [{ name: 'splitting', arg: 'chars' }]
          }
          // this.text
        )
      ]
    )
  }
}
</script>

<style scoped lang="scss">

.split-text {
  display: inline-block;
}

::v-deep {
  .word {
    padding-top: 10px;
    padding-right: 10px;
    margin-top: -10px;
    margin-right: -10px;
    overflow: hidden;
    letter-spacing: -0.01em;

    .no-ios & {
      white-space: nowrap;
    }
  }

  .char {
    top: 0;
  }
}

.v-enter-active,
.v-leave-active {
  transition: transform 1.3s $ease-out-quad, opacity 400ms;

  ::v-deep .char {
    transition: transform 450ms $ease-out-quad, opacity 400ms;
    transition-delay: 0s;
    transition-delay: calc(var(--appear-delay, 10ms) + (10ms * var(--char-index)));
  }
}

.v-enter,
.v-leave-to {
  ::v-deep .char {
    opacity: 0 !important;
    transform: translate3d(0, 30px, 0);
  }
}

.hover-leave-active {
  transition: all 0s;
}

.hover-leave-to {
  opacity: 0;
}

.hover-enter-active {
  transition: opacity 2s;

  ::v-deep .char {
    transition: transform 50ms $ease-in-out-quad, opacity 50ms $ease-in-out-quad;
    transition: transform calc(50ms * var(--char-index)) $ease-in-out-quad, opacity calc(50ms * var(--char-index)) $ease-in-out-quad;
    transition-delay: 0s;
    transition-delay: calc(var(--appear-delay, 10ms) + (10ms * var(--char-index)));
  }
}

.hover-enter {
  ::v-deep .char {
    opacity: 0 !important;
    transform: translate3d(0, 0.5em, 0);
  }
}

</style>
